// extracted by mini-css-extract-plugin
export default {"icon":"ServiceElement_icon__Zv7s8","title":"ServiceElement_title__W3RV0","content":"ServiceElement_content__OAA4z"};